// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type MobileSystemContextProperties = {
  device_udid: string;
  adjust_adid?: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/mobile_system_context/jsonschema/2-0-0';
export const mobileSystemContextName = 'mobile_system_context';
export class MobileSystemContext extends BaseTrackingContext<MobileSystemContextProperties> {
  constructor(properties: MobileSystemContextProperties) {
    super(mobileSystemContextName, schema, properties);
  }
}
